<div
  [class.button-mode]="type == 'button' && !enableSelector"
  [class.item-picker-small-size]="smallSize"
  [class.error]="hasError"
>
  <mat-form-field
    appearance="outline"
    [class.dropdown-field]="!enableSelector"
    floatLabel="always"
    class="mat-select-form-field"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <mat-select
      [required]="required"
      [disabled]="(disabledSelector || disabled) && !enableSelector"
      [placeholder]="placeholder"
      [(value)]="selectedValue"
      #selector
      (closed)="selectorClosed()"
      (opened)="selectorOpened()"
      [panelClass]="
        smallSize
          ? ['item-picker-small-size', 'item-picker-panel']
          : 'item-picker-panel'
      "
    >
      <mat-select-trigger>
        {{ selectedValue?.name }}
      </mat-select-trigger>
      <div class="main-item-picker-container">
        <div class="main-item-picker-search">
          <mat-form-field appearance="outline" appThrottleClick>
            <input
              #searchInput
              matInput
              type="text"
              placeholder="Search..."
              [(ngModel)]="search"
              (keydown)="onSearchKeydown($event)"
            />
          </mat-form-field>
        </div>
        <div class="main-item-picker-items">
          @for (item of data | filter: search; track item) {
            <mat-option
              [value]="item"
              (click)="onClick(item)"
              (keydown.enter)="onClick(item)"
              (keyup)="keyup()"
            >
              @if (item.icon) {
                <mat-icon>{{ item.icon }}</mat-icon>
              }
              <span>{{ item.name }}</span>
            </mat-option>
          }
        </div>
      </div>
      @if (showCreateButton) {
        <div class="item-picker-footer">
          <mat-divider></mat-divider>
          <mat-option (click)="create.emit()">
            <span class="create-button" color="primary">{{
              createButtonText
            }}</span>
          </mat-option>
        </div>
      }
    </mat-select>
  </mat-form-field>
  @if (enableSelector) {
    <button
      type="button"
      class="merge-tag-copy-btn"
      mat-icon-button
      (click)="copySelected()"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
  }
  @if (!enableSelector) {
    <button
      mat-flat-button
      type="button"
      class="mat-secondary-button"
      (click)="openSelector(selector)"
      [disabled]="disabled"
    >
      {{ placeholder }}
    </button>
  }
</div>
@if (hasError && required && type !== 'button') {
  <p class="error-message">
    {{ errorMessage }}
  </p>
}
